import { render, staticRenderFns } from "./AppTestimonials.vue?vue&type=template&id=ec3a1486&"
import script from "./AppTestimonials.vue?vue&type=script&lang=js&"
export * from "./AppTestimonials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AppTestimonials.vue"
export default component.exports